import React, { useEffect, useState } from 'react';
import { Container, Row,Button,Image, Col } from 'react-bootstrap';
import './SwitchBusinessProfile.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Multiselect from "multiselect-react-dropdown";  
import API from '../../../Utils/Api';
import loader from '../../../assests/loader.gif';
import { gettoastwarning } from '../../../Utils/Common';
import {validateswitchbusinessprofile} from '../../../Utils/validate';
import { useNavigate } from "react-router-dom";

//import { LoadScript, Autocomplete } from "@react-google-maps/api";

const SwitchBusinessProfile = () => {

    //const [autocomplete, setAutocomplete] = useState(null);

    const navigate = useNavigate();
   const [errors,setErrors] = useState({});

   const [loading,setLoading] = useState(true);

   const [inputs,setInputs] = useState({business_name:'',email:'',contact_number:'',address:'',business_description:'',pincode:'',state:'',city:'',town:'',category_id:'',latitude:'',longitude:''});

   const [state, setState] = useState([]);
    const [city, setCity] = useState([]);
    const [town, setTown] = useState([]);

    const [category, setCategory] = useState([]);

    useEffect(() => {
        document.title = `Business Profile | Local Bells`;
        document.getElementById('bodywrap').className = 'neviewpro';

        API.get('get_user_detail')
                .then(response => {
                    setLoading(false);
                if(response.data.status === false){
                    
                }else{
                var pincode='';
                  var state='';
                  var city='';
                  var town='';
                  if(response.data.data.location.length > 0)
                  {
                        getCitySel(response.data.data.location[0].state);
                        getTownSel(response.data.data.location[0].city);
                        
                        pincode=response.data.data.location[0].pincode;
                        state=response.data.data.location[0].state;
                        city=response.data.data.location[0].city;
                        town=response.data.data.location[0].town;
                  }

                    setInputs({
                        business_name:'',
                        email:response.data.data.email,
                        contact_number:response.data.data.contact_number,
                        address:'',
                        business_description:'',
                        pincode:pincode,
                        state:state,
                        city:city,
                        town:town,
                        category_id:response.data.data.category_id,
                        latitude:'',
                        longitude:''
                    });
                  
                   
                }                  
            }).catch(error => {
                setLoading(false); 
            });

        API.post('get_business_with_user_login')
                .then(response => {
                    setLoading(false);
                if(response.data.status === false){
                    
                }else{

                }                  
            }).catch(error => {
                
            });  
        API.post('get_state')
              .then(response => {
              setState(response.data.data);       
          });

          API.post('get_categories')
                .then(response => {
                  
                if(response.data.status === true){
                 setCategory(response.data.data);  
                }else{
                      
                }
              }).catch(error => {
                  
          }); 

    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };
    const handleInputChange = (event) => {
        event.persist();
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
    }
    /* Start Value set */
    /*const handleInputChange = (event) => {
      event.persist();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));       
    }*/
    /*const handleInputChangeEmail = (event) => {
      event.persist();
      const { name, value } = event.target;

      // Regex for allowed email characters
      const regex = /^[a-zA-Z0-9@._-]*$/;

      if (regex.test(value)) {
        setInputs(inputs => ({ ...inputs, [name]: value }));
      }        
    }*/
    /*const handleInputChangeMo = (event) => {
      event.persist();
      const { name, value } = event.target;

      // Allow only numbers (0–9)
      const regex = /^[0-9]*$/;

      if (regex.test(value)) {
        setInputs(inputs => ({ ...inputs, [name]: value }));
      }      
    }*/
    const handleInputChangeSpe = (event) => {
      event.persist();
      const { name, value } = event.target;

      // Allow only letters, numbers, spaces, and basic punctuation if needed
      const regex = /^[a-zA-Z0-9\s]*$/;

      if (regex.test(value)) {
        setInputs(inputs => ({ ...inputs, [name]: value }));
      }    
    }
    const handleCategorySelect = (selectedList) => {
        const ids = selectedList.map(lang => lang.id);
        setInputs(prev => ({ ...prev, category_id: ids }));

        setTimeout(() => {
            document.querySelector(".custom-multiselect input")?.blur();
          }, 50);
    };

      const handleCategoryRemove = (selectedList) => {
        const ids = selectedList.map(lang => lang.id);
        setInputs(prev => ({ ...prev, category_id: ids }));
      };
    /* End Value set */

      /*const getCity = (event) => {     
          event.preventDefault();
          setInputs(inputs => ({...inputs, [event.target.name]: event.target.value})); 

          setTown([]);  
         

          var st='city';
          var st_val='';
           setInputs(inputs => ({...inputs, [st]: st_val})); 

           var ct='town';
          var ct_val='';
           setInputs(inputs => ({...inputs, [ct]: ct_val})); 

           var ctt='category_id';
      var ctt_val='';
       setInputs(inputs => ({...inputs, [ctt]: ctt_val})); 

          let formData = new FormData(); 
              formData.append('state_id', event.target.value);
              API.post('get_city', formData)
                        .then(response => {
                          
                        if(response.data.status === true){
                         setCity(response.data.data);  
                        }else{
                            
                             
                        }
                      }).catch(error => {
                          
                  }); 

      }*/

    /*const getTown = (event) => {     
      event.preventDefault();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value})); 

      setTown([]);  
      
       var ct='town';
      var ct_val='';
       setInputs(inputs => ({...inputs, [ct]: ct_val})); 

       var ctt='category_id';
      var ctt_val='';
       setInputs(inputs => ({...inputs, [ctt]: ctt_val})); 

      let formData = new FormData(); 
          formData.append('city_id', event.target.value);
          API.post('get_town', formData)
                .then(response => {
                  
                if(response.data.status === true){
                 setTown(response.data.data);  
                }else{
                    
                     
                }
              }).catch(error => {
                  
          }); 
    }*/
    /*const getCat = (event) => {     
      event.preventDefault();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value})); 
    }*/

const getCitySel = (state_id) => {     
  let formData = new FormData(); 
      formData.append('state_id', state_id);
      API.post('get_city', formData)
                .then(response => {
                  
                if(response.data.status === true){
                 setCity(response.data.data);  
                }else{
                     
                }
              }).catch(error => {
                  
          }); 
}

const getTownSel = (city_id) => {     
      let formData = new FormData(); 
          formData.append('city_id', city_id);
          API.post('get_town', formData)
                    .then(response => {
                      
                    if(response.data.status === true){
                     setTown(response.data.data);  
                    }else{
                        
                    }
                  }).catch(error => {
                      
              }); 
}


    const handleSubmit = (e) => {
        e.preventDefault();        
       

        const validationErrors = validateswitchbusinessprofile(inputs);
        const noErrors = Object.keys(validationErrors).length === 0;

        setErrors(validationErrors);

        /*const generalErrors = Object.keys(validationErrors).filter(
          key => !key.startsWith('hour_')
        );
        const hasGeneralError = generalErrors.length > 0;

        const hourErrorsValid = Object.keys(validationErrors)
          .filter(key => key.startsWith('hour_'))
          .every(key => Object.keys(validationErrors[key]).length === 0);

        const noErrors = !hasGeneralError && hourErrorsValid;*/

        if(noErrors){
            setLoading(true);
            
            let formData = new FormData(); 
            Object.keys(inputs).forEach((key) => {
                if (key === 'category_id') {
                    formData.append('categories', inputs.category_id.join(','));
                  } else {
                    formData.append(key, inputs[key]);
                }
            });
            

            API.post('add_business_with_user_login', formData)
              .then(response => {
              if(response.data.status === false){
                setLoading(false); 
                gettoastwarning(response.data.message,'');
              }else{
                 setLoading(false);
                 localStorage.setItem("business_id", response.data.data.business_id);

                 var is_profile_verify2=1;
                localStorage.setItem("is_profile_verify_buss", is_profile_verify2);
                 window.location.href = "/business/my-deal";
              }                  
            }).catch(error => {
               setLoading(false);
               gettoastwarning("Something went wrong. Please try again later.",'');
                //setError("Something went wrong. Please try again later.");
            });
        }
    };

/*const onLoad = (auto) => setAutocomplete(auto);

  const onPlaceChanged = () => {
    if (!autocomplete) return;

    const place = autocomplete.getPlace();

    var albl = 'address';
    setInputs(inputs => ({ ...inputs, [albl]: place.formatted_address }));
    
    if (place.geometry && place.geometry.location) {

        var latlbl = 'latitude';
        setInputs(inputs => ({ ...inputs, [latlbl]: place.geometry.location.lat() }));

        var longlbl = 'longitude';
        setInputs(inputs => ({ ...inputs, [longlbl]: place.geometry.location.lng() }));

      
    }

  };

  const handleChange = (e) => {
    setInputs((prev) => ({
      ...prev,
      address: e.target.value,
    }));
  };*/

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <div className='white-box business-form'>
                                    <div className='d-flex align-items-center justify-content-between gap-2'>
                                    <h3 className='mb-3'>Add Business Page</h3>
                                    <div className='close-box-pro mb-3 wp-link' onClick={() => navigate(-1)} style={{ cursor: "pointer" }}><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid" alt="wp" /></div>
                                </div>
                                    <Form onSubmit={handleSubmit}>
                                        <Row>
                                            <Col md={12} lg={12} xl={5}>                                               
                                                {/*<Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>First Name</Form.Label>
                                                    <Form.Control type="text" placeholder="First Name" name="first_name" value={inputs.first_name} disabled />
                                                </Form.Group>
                                                {errors.first_name && (<p className="text-danger">{errors.first_name}</p>)}
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Last Name</Form.Label>
                                                    <Form.Control type="text" placeholder="Last Name" name="last_name" value={inputs.last_name} disabled />
                                                </Form.Group>
                                                {errors.last_name && (<p className="text-danger">{errors.last_name}</p>)}*/}
                                                
                                                <Form.Group className="mb-3">
                                                    <Form.Label className=''>Business Email</Form.Label>
                                                    <Form.Control type="text" placeholder="Business Email" name="email" value={inputs.email} disabled />
                                                </Form.Group>
                                                {errors.email && (<p className="text-danger">{errors.email}</p>)}
                                                <Form.Label className=''>Contact Number</Form.Label>
                                                <InputGroup className="anb-cont mb-3">
                                                    <Form.Control
                                                        placeholder="Contact No"
                                                        aria-label="cntno"
                                                        aria-describedby="cntno"
                                                        type="text"
                                                        name="contact_number" value={inputs.contact_number}
                                                        maxLength={15}
                                                        disabled
                                                    />
                                                    {/*<InputGroup.Text id="cntno">
                                                        <Link to="/">Verify phone number</Link>
                                                    </InputGroup.Text>*/}
                                                </InputGroup>
                                                {errors.contact_number && (<p className="text-danger">{errors.contact_number}</p>)}
                                                
                                                 <Form.Group className="mb-3">
                                                    <Form.Label className=''>Pin code</Form.Label>
                                                    <Form.Control type="text" placeholder="Pin code" name="pincode" disabled value={inputs.pincode} />
                                                </Form.Group>
                                                {errors.pincode && (<p className="text-danger">{errors.pincode}</p>)}
                                                                                               
                                                <Row>
                                                    <Col md={4}>
                                                    <Form.Label className=''>State</Form.Label>
                                                        <Form.Select aria-label="Default select example" name="state" disabled value={inputs.state}>
                                                            <option value="">State</option>
                                                            {state && state.map((val, index) => {
                                                               return (
                                                                    <option value={val.id}>{val.name}</option>
                                                                )
                                                            })}
                                                        </Form.Select>
                                                        {errors.state && (<p className="text-danger">{errors.state}</p>)}           
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Label className=''>City</Form.Label>
                                                        <Form.Select aria-label="Default select example" name="city" disabled value={inputs.city}>
                                                            <option value="">City</option>
                                                            {city && city.map((val, index) => {
                                                               return (
                                                                                                <option value={val.id}>{val.name}</option>
                                                                                            )
                                                              })}
                                                        </Form.Select>
                                                        {errors.city && (<p className="text-danger">{errors.city}</p>)}
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Label className=''>Locality</Form.Label>
                                                        <Form.Select aria-label="Default select example" name="town" disabled value={inputs.town}>
                                                            <option value="">Locality </option>
                                                                {town && town.map((val, index) => {
                                                       return ( 
                                                                <option value={val.id}>{val.name}</option>
                                                             )
                                                        })}
                                                        </Form.Select>
                                                        {errors.town && (<p className="text-danger">{errors.town}</p>)}
                                                    </Col>
                                                </Row>

                                                
                                                
                                                 
                                            </Col>
                                            <Col md={12} lg={12} xl={7}>
                                               <Form.Group className="mb-3">
                                                    <Form.Label className=''>Business Name</Form.Label>
                                                    <Form.Control type="text" placeholder="Business Name" name="business_name" onChange={handleInputChangeSpe} value={inputs.business_name} />
                                                </Form.Group>
                                                {errors.business_name && (<p className="text-danger">{errors.business_name}</p>)}                                          
                                                {/*<Form.Group className="mb-3">
                                                    <Form.Label className=''>Business Address</Form.Label>
                                                    <Form.Control as="textarea" rows={4} placeholder='Business Address' name="address" onChange={handleInputChange} value={inputs.address} />
                                                </Form.Group>
                                                {errors.address && (<p className="text-danger">{errors.address}</p>)}*/}
                                                <div className="mb-3">
                                                    <Form.Label className=''>Business Address</Form.Label>
                                                <Form.Control as="textarea" rows={3} placeholder='Business Address' name="address" onChange={handleInputChange} value={inputs.address} />
                                                
                                                {/*<LoadScript
                                                  googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                                                  libraries={["places"]}
                                                  version="weekly"
                                                >
                                                  <Autocomplete
                                                    onLoad={onLoad}
                                                    onPlaceChanged={onPlaceChanged}
                                                    options={{
                                                      types: ["geocode"],
                                                      componentRestrictions: { country: "in" }
                                                    }}
                                                  >
                                                    <input
                                                      type="text"
                                                      placeholder="Enter address"
                                                      className="form-control"
                                                      value={inputs.address}
                                                      onChange={handleChange}
                                                    />
                                                  </Autocomplete>
                                                </LoadScript>*/}
                                                {errors.address && (<p className="text-danger">{errors.address}</p>)}
                                            </div>
                                                <Form.Label className=''>Category</Form.Label>
                                                <div className="position-relative">
                                                    <div className="multi-drop-box">
                                                        X
                                                    </div>
                                                <Multiselect
                                                  options={category}
                                                  selectedValues={category.filter(lang =>
                                                    (inputs.category_id || []).includes(lang.id)
                                                  )}
                                                  onSelect={handleCategorySelect}
                                                  onRemove={handleCategoryRemove}
                                                  placeholder="Select Category"
                                                  className="custom-multiselect"
                                                  displayValue="name"
                                                  showArrow={false}
                                                />
                                                </div>
                                                {errors.category_id && (<p className="text-danger">{errors.category_id}</p>)}

                                            
                                                <Button variant="primary" type="submit" className='orange-btn'>
                                                    <h6>Launch Business</h6>
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                                <div className='footer-main footer'>
                                    <Footer />                                
                                </div>                                 
                                
                                    
                                    
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
           {loading && (
               <div className="loadingClass">
                <img src={loader} alt="loader"/>
              </div>
               )}
        </>
    )
}

export default SwitchBusinessProfile;


